// NPM
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from "recoil";
import { isNil } from 'lodash';
import {Helmet} from "react-helmet";

// SERVICE
import { fetchPaymentStatus } from 'Services/payment.services';

// ATOM
import { paymentStatusAtom, paymentDetailsAtom, paymentErrorAtom } from "Recoil/payment.atom";

// HELPERS
import { decode, getWithExpiry } from 'Helpers/index';

// HOOKS
import { useQuery } from 'Hooks/index';

// COMPONENTS
import OrderPaymentStatus from 'Components/order/order-payment-status';

// STYLE
import './order-payment-status.scss';

interface OrderPaymentStatusPageProps {};

const OrderPaymentStatusPage: React.FC<OrderPaymentStatusPageProps> = () => {
  const history = useHistory();
  const query = useQuery();
  const ref = query.get('ref');
  const req = getWithExpiry(process.env.AWAITING_PAYMENT_ORDER_ID);
  // If can't get orderID from queryString, try to get from localStorage (only valid for 15 minutes)
  const paymentID = ref ? decode(ref) : req.paymentID;

  const [status, setStatus] = useRecoilState<any>(paymentStatusAtom);
  const [paymentDetails, setPaymentDetails] = useRecoilState<any>(paymentDetailsAtom);
  const [error, setError] = useRecoilState<any>(paymentErrorAtom);

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    if (paymentID) {
      setStatus({ ...status, fetch: 'loading' });
      const responseData = await fetchPaymentStatus({ paymentID });

      if (!isNil(responseData.error)) {
        if (responseData.error.code === '4010') {
          responseData.error.value = 'error.orderPaymentStatusPageExpired'
        }

        setStatus({ ...status,  fetch: 'error' });
        setError(responseData?.error);
      }
      else {
        setStatus({ ...status,  fetch: 'success' });
        setPaymentDetails(responseData);
      }
    }
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>
          Payment
        </title>
      </Helmet>
      <div className="page order-payment-status-page">
        <div className="gradient-bg" />

        <div className="page--container">
          <OrderPaymentStatus
            data={paymentDetails}
            status={status.fetch}
            resError={error}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default OrderPaymentStatusPage;
